export enum ToastType {
  Default = 'default',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger'
}
